var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup12213(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 183,
    viewBox: "0 0 885 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_43_48589)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 851,
    height: 123,
    rx: 10.5743,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.6782,
    y: 4.67821,
    width: 853.644,
    height: 125.644,
    rx: 11.8961,
    stroke: "#EBEBEB",
    strokeWidth: 2.64359
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_48589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 6,
    width: 851,
    height: 123
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 851,
    height: 123,
    rx: 10.5743,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_48589)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_43_48589)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.515,
    cy: 118.297,
    rx: 127.515,
    ry: 118.297,
    transform: "matrix(-1 0 0 1 978.254 -13.9722)",
    fill: "#FE8616"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_43_48589)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.8162,
    cy: 68.3664,
    rx: 76.8162,
    ry: 68.3664,
    transform: "matrix(-1 0 0 1 761.632 61.3076)",
    fill: "#F9D411"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M828.796 50.6966C828.796 52.5034 829.098 54.3102 829.7 56.1171H797.719C797.117 53.9489 796.816 51.1182 796.816 47.625C796.816 34.4955 801.574 24.1365 811.09 16.5478C820.606 8.83876 834.277 4.98423 852.104 4.98423C866.318 4.98423 877.099 7.99558 884.446 14.0183C891.794 19.9206 895.468 28.1114 895.468 38.591C895.468 47.1432 892.637 55.2137 886.976 62.8023C881.315 70.3909 874.81 74.1852 867.462 74.1852V74.7272C873.124 74.7272 877.641 76.7147 881.013 80.6897C884.386 84.6647 886.072 89.8443 886.072 96.2283C886.072 124.656 867.161 138.869 829.339 138.869C813.559 138.869 801.935 135.256 794.467 128.028C788.926 122.728 786.156 115.381 786.156 105.985C786.156 102.612 786.517 98.9988 787.24 95.1442H819.762C819.522 96.4692 819.401 97.734 819.401 98.9386C819.401 106.889 824.581 110.864 834.94 110.864C840.36 110.864 844.877 109.298 848.491 106.166C852.104 103.034 853.911 99.1795 853.911 94.6022C853.911 87.6159 849.334 84.1227 840.179 84.1227H821.931L825.544 64.4284H839.999C846.262 64.308 851.502 62.3807 855.718 58.6466C860.054 54.7921 862.223 50.6364 862.223 46.1796C862.223 41.7228 860.837 38.4103 858.067 36.2421C855.417 34.0739 851.442 32.9898 846.142 32.9898C840.842 32.9898 836.626 34.616 833.494 37.8682C830.362 41.0001 828.796 45.2762 828.796 50.6966Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_43_48589",
    x: 0.529495,
    y: 0.283766,
    width: 883.941,
    height: 182.059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.53632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.30449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_43_48589"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.21795
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.60897
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_43_48589",
    result: "effect2_dropShadow_43_48589"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.9722
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1453
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_43_48589",
    result: "effect3_dropShadow_43_48589"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36.8718
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.91346
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_43_48589",
    result: "effect4_dropShadow_43_48589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_43_48589",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_43_48589",
    x: 538.865,
    y: -198.331,
    width: 623.748,
    height: 605.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.1795,
    result: "effect1_foregroundBlur_43_48589"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_43_48589",
    x: 423.641,
    y: -123.051,
    width: 522.35,
    height: 505.451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 92.1795,
    result: "effect1_foregroundBlur_43_48589"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12213);
export default __webpack_public_path__ + "static/media/Group 1221 (3).a662df9fab6f9eb1cf89f47c866e6be2.svg";
export { ForwardRef as ReactComponent };